<template>
  <div class="query-group" @keydown.enter="query">
    <div class="expand-area" ref="groupEl">
      <el-form class="global-reset-form" :inline="inline" :label-position="labelPosition" @submit.prevent>
        <slot></slot>
      </el-form>
      <div v-if="!hideButton && (!expand) || !hideButton && (!showExpand)"
        :class="{ toos: expand && showExpand, showExpand: showExpand }" style="flex-shrink: 0; text-align: right;"
        :style="{ width: showExpand ? '206px' : '146px' }">
        <slot name="button">
          <el-button type="primary" @click="query">查询</el-button>
          <el-button type="default" @click="reset">重置</el-button>
          <el-button type="text" @click="changeExpand" v-if="showExpand">
            <template v-if="!expand"> 展开 <i class="el-icon-arrow-down"></i> </template>
            <template v-else> 收起 <i class="el-icon-arrow-up"></i> </template>
          </el-button>
        </slot>
      </div>
    </div>
    <div v-if="expand && showExpand" style="flex-shrink: 0; text-align: right;"
      :style="{ width: '100%', 'margin-bottom': '20px' }">
      <slot name="button">
        <el-button type="primary" @click="query">查询</el-button>
        <el-button type="default" @click="reset">重置</el-button>
        <el-button type="text" @click="changeExpand" v-if="showExpand">
          <template v-if="!expand"> 展开 <i class="el-icon-arrow-down"></i> </template>
          <template v-else> 收起 <i class="el-icon-arrow-up"></i> </template>
        </el-button>
      </slot>
    </div>
    <slot name="append"></slot>
  </div>
</template>

<script>
import {
  inject, provide, reactive, toRaw, toRef, watch,
} from 'vue';

import { cloneDeep } from 'lodash';
import useExpand from './useExpand';

export default {
  name: 'yx-query-group',
  props: {
    immediate: {
      type: Boolean,
      default: true,
    },
    inline: {
      type: Boolean,
      default: true,
    },
    labelWidth: {
      type: [String, Number],
      default: '110px',
    },
    labelPosition: {
      type: String,
      default: 'right',
    },
    hideButton: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    provide('is-yx-query-group', true);
    provide('is-yx-query', false);
    const emitFn = inject('useQueryPage-query-group');

    const form = reactive({});
    const resetList = [];
    function regist(callback) {
      resetList.push(callback);
    }

    const {
      expand, showExpand, groupEl, changeExpand,
    } = useExpand(props.hideButton);

    provide('useQuery', (key, initVal, resetFn) => {
      // 运行时检查form的key是否重复.不抛出错误
      if (form[key] !== undefined) {
        throw new Error('query-group的form有重复的key:', key);
      }
      form[key] = cloneDeep(initVal);
      if (resetFn && typeof resetFn === 'function') {
        regist(resetFn);
      } else {
        regist(() => {
          form[key] = cloneDeep(initVal);
        });
      }
      return toRef(form, key);
    });

    function query() {
      const params = cloneDeep(toRaw(form));
      context.emit('query', params);
      if (emitFn) {
        emitFn(params, 'query');
      }
    }
    if (props.immediate) {
      setTimeout(query, 0);
    }

    function reset() {
      resetList.forEach((fn) => fn());
      const params = cloneDeep(toRaw(form));
      context.emit('reset', params);
      if (emitFn) {
        emitFn(params, 'reset');
      }
    }
    watch(() => expand.value, (nval) => {
      context.emit('expand', nval);
    });

    return {
      expand,
      showExpand,
      groupEl,
      changeExpand,
      query,
      reset,
    };
  },
};
</script>

<style lang="scss">
.expand-area {
  overflow: hidden;
  position: relative;
  display: flex;

  .expand {
    width: 0 !important;
    height: 0 !important;
    font-size: 0;

    &.show {
      display: inline-block;
    }
  }
}

.query-group .el-form-item__label {
  // width: 110px !important;
  padding-right: 8px !important;
}

.query-group .el-form-item {
  margin-right: 24px !important;
  margin-bottom: 24px !important;
  // line-height: 36px !important;
}

// .query-group .el-form-item__content {
//   line-height: 36px !important;
// }

.query-group .el-input {
  width: 222px !important;
}

.query-group .el-date-editor.el-range-editor {
  width: 222px !important;
}

.query-group .el-date-editor.el-range-editor .el-range-separator {
  padding: 0 !important;
  width: 10% !important;
}

.query-group .el-checkbox,
.query-group .el-radio {
  font-weight: 400 !important;
}

.global-reset-form {
  flex: 1;

  .el-form-item {
    margin-bottom: 14px !important;
    vertical-align: baseline !important;
  }
}

.toos {
  position: absolute;
}

.showExpand {
  right: 0px;
  bottom: 5px;
}</style>
